"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconInvoice = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconInvoice = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M6.29 22.3a3.033 3.033 0 0 1-2.223-.927 3.025 3.025 0 0 1-.926-2.22V15.8h3.05V1.792l1.534 1.342L9.28 1.792l1.554 1.342 1.554-1.342 1.554 1.342 1.553-1.342 1.554 1.342 1.554-1.342 1.554 1.342 1.535-1.342v17.357c0 .866-.309 1.607-.926 2.224a3.033 3.033 0 0 1-2.224.926H6.29Zm12.25-2.15a.971.971 0 0 0 .713-.288.968.968 0 0 0 .288-.713V4.85H8.34V15.8h9.2v3.35a.97.97 0 0 0 .287.713c.192.191.43.287.713.287ZM9.334 9V6.85h8.887V9H9.333Zm0 3.45V10.3h8.887v2.15H9.333Zm-3.042 7.7h9.1v-2.2H5.29v1.2c0 .283.095.52.287.712.192.191.43.287.713.287Z"
}));
exports.IconInvoice = IconInvoice;
//# sourceMappingURL=IconInvoice.js.map